import { ChangeDetectorRef, Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import swal from 'sweetalert2';
import { Cliente } from 'src/app/shared/model/ajustesUsuario/cliente.model';
import { GestionclientesService } from '../gestionclientes.service';
import { TipoCliente } from 'src/app/shared/model/ajustesUsuario/tipo.cliente';
import { SegmentoCliente } from 'src/app/shared/model/ajustesUsuario/segmento.cliente';
import { TamanioCliente } from 'src/app/shared/model/ajustesUsuario/tamanio.cliente';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';
import { NgIf, NgFor } from '@angular/common';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';


@Component({
    selector: 'app-modificarmodal',
    templateUrl: './modificarmodal.component.html',
    styleUrls: ['./modificarmodal.component.css'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, NgIf, MatError, MatSelect, NgFor, MatOption, MatRadioGroup, MatRadioButton, MatButton, MatIcon, MatIconButton]
})
export class ModificarmodalComponent implements OnInit {
  datos: FormGroup;
  clienteActual = new Cliente();
  listTipos: TipoCliente[] = [];
  listSegmentos: SegmentoCliente[] = [];
  listTamanios: TamanioCliente[] = [];
  esProspectoRfc: boolean = false;
  esProspectoRepresentante: boolean = false;
  esProspecto: boolean = false;
  idProyectoCliente: string = '';


  constructor(
    public dialogRef: MatDialogRef<ModificarmodalComponent>,
    @Inject(MAT_DIALOG_DATA) private data: Cliente,
    private formbuilder: FormBuilder,
    private clienteService: GestionclientesService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.clienteActual.id = this.data.id;
    this.clienteActual.razonsocial = this.data.razonsocial;
    this.clienteActual.rfc = this.data.rfc;
    this.clienteActual.representante = this.data.representante;
    this.clienteActual.email = this.data.email;
    this.clienteActual.telefono = this.data.telefono;
    this.clienteActual.comentarios = this.data.comentarios;
    this.clienteActual.estatus = this.data.estatus;
    this.clienteActual.fechaAlta = this.data.fechaAlta;
    this.clienteActual.idcorporativo = this.data.idcorporativo;
    this.clienteActual.idempresa = this.data.idempresa;

    this.clienteActual.idtipo = this.data.idtipo;
    this.clienteActual.idsegmento = this.data.idsegmento;
    this.clienteActual.idtamanio = this.data.idtamanio;
    this.clienteActual.formacontacto = this.data.formacontacto;
    this.clienteActual.esProspecto = this.data.esProspecto;
    this.clienteActual.extensionTel = this.data.extensionTel;
    this.clienteActual.nombreContacto = this.data.nombreContacto;
    this.clienteActual.idProyecto = this.data.idProyecto;
    this.clienteActual.nombre_corto = this.data.nombre_corto;

    this.formUpdate();
    this.applyProspectState();
    queueMicrotask(() => this.cdr.detectChanges());
  }

  consultaTipos(): void {
    let tipo:TipoCliente = new TipoCliente();
    tipo.estatus = "ACTIVO";

    this.clienteService.consultaTipos(tipo).subscribe(res => {
      this.listTipos = Array.isArray(res?.list) ? res.list : [];
      if (!this.clienteActual.idtipo && this.listTipos.length === 1) {
        this.clienteActual.idtipo = this.listTipos[0].id;
        this.datos.controls.tipo.setValue(this.clienteActual.idtipo);
      }
      this.cdr.detectChanges();
    });
  }

  consultaSegmento(): void {
    let segmento:SegmentoCliente = new SegmentoCliente();
    segmento.estatus = "ACTIVO";

    this.clienteService.consultaSegmento(segmento).subscribe(res => {
      this.listSegmentos = Array.isArray(res?.list) ? res.list : [];
      if (!this.clienteActual.idsegmento && this.listSegmentos.length === 1) {
        this.clienteActual.idsegmento = this.listSegmentos[0].id;
        this.datos.controls.segmento.setValue(this.clienteActual.idsegmento);
      }
      this.cdr.detectChanges();
    });
  }

  consultaTamanio(): void {
    let tam : TamanioCliente = new TamanioCliente();
    tam.estatus  = "ACTIVO";

    this.clienteService.consultaTamanio(tam).subscribe(res => {
      this.listTamanios = Array.isArray(res?.list) ? res.list : [];
      if (!this.clienteActual.idtamanio && this.listTamanios.length === 1) {
        this.clienteActual.idtamanio = this.listTamanios[0].id;
        this.datos.controls.tam.setValue(this.clienteActual.idtamanio);
      }
      this.cdr.detectChanges();
    });
  }
  
  

  guarda(){
    if(this.datos.valid){
      this.clienteActual.idProyecto = this.clienteActual.idProyecto.toUpperCase();
      this.clienteService.saveUpdateCLient(this.clienteActual).subscribe(resp => {
        swal.fire({
          text: 'cliente actualizado exitosamente',
          buttonsStyling: false,
          customClass:{
            confirmButton: 'btn btn-success',
   
          },
          icon: 'success',

          }).then(() => {
            this.onNoClick();
          })
      }) 
      swal.fire({
        text: 'Incidencia insertada exitosamente',
        buttonsStyling: false,
        customClass:{
          confirmButton: 'btn btn-success',
 
        },
        icon: 'success',

      }).then(() => {
        this.onNoClick();
      })
    } else{
      swal.fire({
     text: 'No se permite dejar campos vacíos',
     buttonsStyling: false,
     customClass:{
      confirmButton: 'btn btn-danger',

    },
     icon: 'error'
     })
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  formUpdate(){
    this.datos = this.formbuilder.group({
      rSocial: [this.clienteActual.razonsocial || '', [Validators.required]],
      rfc: [
        this.clienteActual.rfc || '',
        [
          Validators.required,
          Validators.pattern(
            '^[A-ZÑ&]{3,4}[0-9]{2}' +              // 3 o 4 letras iniciales (moral o física)
            '(0[1-9]|1[0-2])' +                    // mes válido
            '(0[1-9]|[12][0-9]|3[01])' +           // día válido
            '[A-Z0-9]{2,3}$'                       // homoclave de 2 o 3 caracteres
          )
        ]
      ],
      represent: [this.clienteActual.representante || ''],
      email: [this.clienteActual.email || '', [Validators.required, Validators.email]],
      tel: [this.clienteActual.telefono || '', [Validators.required]],
      tipo: [this.clienteActual.idtipo || '', [Validators.required]],
      segmento: [this.clienteActual.idsegmento || '', [Validators.required]],
      tam: [this.clienteActual.idtamanio || '', [Validators.required]],
      forma: [this.clienteActual.formacontacto || '', [Validators.required]],
      ref: [this.clienteActual.comentarios || '', [Validators.required]],
      idProyecto: [this.clienteActual.idProyecto || ''],
      nombreContacto: [this.clienteActual.nombreContacto || '', [Validators.required]],
      extensionTel: [this.clienteActual.extensionTel || '', [Validators.required]],
      nombre_corto: [this.clienteActual.nombre_corto || '', [Validators.required, Validators.pattern('^[a-zA-Z0-9]+$')]],
      esProspecto: [this.clienteActual.esProspecto ?? 0],
    });

    this.consultaTipos();
    this.consultaSegmento();
    this.consultaTamanio();
  }

onToggleChange(event: MatSlideToggleChange): void {
  if (this.clienteActual.esProspecto  === 1) {
    this.esProspectoRepresentante = true;
    this.esProspectoRfc = true;
  } else {
    this.esProspectoRepresentante = false;
    this.esProspectoRfc = false;
  }
}

onRadioCompromisoChange() {
  this.applyProspectState();
}

private applyProspectState(): void {
  if (this.clienteActual.esProspecto === 1) {
    this.esProspectoRepresentante = true;
    this.esProspectoRfc = true;
  }else{
    this.esProspectoRepresentante = false;
    this.esProspectoRfc = false;
  }
}

}
